import {
  FormControlledVerticalTabProps,
  IDepartmentResponse,
} from "@miplatform/types";

export enum ContactMethod {
  Email = "Email",
  Phone = "Phone",
}

export interface IRoleData {
  id: string;
  name: string;
  key?: string;
}
export interface IUserFormData {
  id?: string;
  firstName: string;
  lastName: string;
  displayName: string;
  userName: string;
  primaryPhoneNumber: string;
  email: string;
  preferredContactMethod: ContactMethod;
  primaryLocation: string;
  timezone: string;
  language: string;
  roles?: IRoleData[];
  departments?: IDepartmentResponse[];
}

export type UserDetailsTabProps = FormControlledVerticalTabProps<IUserFormData>;
